import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    let deviceId = localStorage.getItem("revimenu_device_id")
    if (!deviceId) {
      deviceId = typeof crypto.randomUUID === "function"
        ? crypto.randomUUID()
        : ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16))
      localStorage.setItem("revimenu_device_id", deviceId)
    }
    this.element.value = deviceId
  }
}
